import React, { useEffect, useMemo, useState } from 'react';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../components/Component';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import CardTabs from '../../components/cards/CardTabs';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import { RETRIEVE_TENANT_STOCK_TAKE_DETAILS_API } from '../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { fail_retrieve_tenant_stock_take_details, loading_retrieve_tenant_stock_take_details, reset_retrieve_tenant_stock_take_details, success_retrieve_tenant_stock_take_details } from '../../../reducers/auth_tenant/retrieve_tenant_stock_take_details_Slice';
import { RETRIEVE_TENANT_STOCK_TAKE_DETAILS_ERROR_MSG, RETRIEVE_TENANT_STOCK_TAKE_DETAILS_SUCCESS_MSG } from '../../../utils/error_success_messages';
import * as app_consts from "../../../utils/app_consts";
import { addThreeDots, formatNumber, formatToSentenceCase, messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import ListText from '../../components/text/ListText';
import moment from 'moment';
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { download, generateCsv, mkConfig } from "export-to-csv";
import UploadStockTakeReportModal from '../../../components/modal/UploadStockTakeReportModal';
import { PDFViewer } from '@react-pdf/renderer';
import StockTakePDF from '../../../components/pdf/StockTakePDF';
import ViewHistoryDetailsModal from '../../../components/modal/ViewHistoryDetailsModal';
import UpdateStockTakeValuesToPhysicalStockModal from '../../../components/modal/UpdateStockTakeValuesToPhysicalStockModal';
import UpdateStockTakeReportPDF from '../../../components/pdf/UpdateStockTakeReportPDF';
import UpdateStockTakeProducts from '../../../components/modal/UpdateStockTakeProducts';

const StockTakeDetails = ({ tenant_info, user_info }) => {

  const { reference_number } = useParams();
  const [page_data, setPageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [sm, updateSm] = useState(false);
  const [activeCardTab, setActiveCardTab] = useState("Main Info");
  const dispatch = useDispatch();
  const [productsPerPage] = useState(10);
  const [currentProductsPage, setCurrentProductsPage] = useState(1);
  const paginate = (pageNumber) => setCurrentProductsPage(pageNumber);
  const [upload_stock_take_report_modal, setUploadStockTakeReportModal] = useState(false);
  const [stockTakeHistoryPerPage] = useState(400);
  const [currentStockTakeHistoryPage, setCurrentStockTakeHistoryPage] = useState(1);
  const paginate_stocktake_history = (pageNumber) => setCurrentStockTakeHistoryPage(pageNumber);
  const [view_history_modal, setViewHistoryModal] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState([]);
  const [update_physical_stock_modal, setUpdatePhysicalStockModal] = useState(false);
  const [update_stock_take_products_modal, setUpdateStockTakeProductsModal] = useState(false);


  // Retreive Product
  useEffect(() => {
    retreive_stock_take_details();
  }, []);

  // Retrieve Product
  const retreive_stock_take_details = () => {
    setError("");
    setLoading(true);
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_stock_take_details, success_retrieve_tenant_stock_take_details, fail_retrieve_tenant_stock_take_details, RETRIEVE_TENANT_STOCK_TAKE_DETAILS_ERROR_MSG, RETRIEVE_TENANT_STOCK_TAKE_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_STOCK_TAKE_DETAILS_API}/${reference_number}`));
  };

  // Listener
  const retrieve_tenant_stock_take_details_listener = useSelector((state) => state.retrieve_tenant_stock_take_details.retrieve_tenant_stock_take_details);

  useEffect(() => {
    if (retrieve_tenant_stock_take_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_stock_take_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_stock_take_details_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_stock_take_details_listener.message);
          messageToast(retrieve_tenant_stock_take_details_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_stock_take_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_stock_take_details_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_stock_take_details());
      }
    }
  }, [retrieve_tenant_stock_take_details_listener]);


  // Card Tabs
  const tabs = [
    {
      tabName: "Main Info"
    },
    {
      tabName: "Stock Take Products"
    },
    {
      tabName: "Stock Take History"
    },
    {
      tabName: "Initial Stock Take Report PDF"
    },
    {
      tabName: "Final Stock Take Report PDF"
    },
    {
      // tabName: "Stock Take Full Report"
    }
  ];

  const indexOfLastProduct = currentProductsPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = page_data?.products?.slice(indexOfFirstProduct, indexOfLastProduct);

  const export_to_csv = async (e) => {
    e.preventDefault();
    const cur_dt = moment().format("DD-MM-YYYY h:mm:ss a");

    const csv_headers = ["product_id", "product_name", "color", "size", "product_type", "category", "product_value", "physical_stock"];

    const options = mkConfig({
      fieldSeparator: ',',
      quoteStrings: '"',
      showLabels: true,
      showTitle: false,
      title: " ",
      useTextFile: false,
      useBom: true,
      filename: `${reference_number} Stock Take CSV - Generated on ${cur_dt}`,
      useKeysAsHeaders: false,
      columnHeaders: csv_headers,
    });

    const csv = generateCsv(options)(page_data?.products || []);

    download(options)(csv);
  };

  const closeUploadStockTakeModal = () => {
    setUploadStockTakeReportModal(!upload_stock_take_report_modal);
  };

  const successUploadStockTakeReport = () => {
    retreive_stock_take_details();
    closeUploadStockTakeModal();
    setActiveCardTab("Initial Stock Take Report PDF");
  };


  const indexOfLastStockTakeHistory = currentStockTakeHistoryPage * stockTakeHistoryPerPage;
  const indexOfFirstStockTakeHistory = indexOfLastStockTakeHistory - stockTakeHistoryPerPage;
  const currentStockTakeHistory = page_data?.history?.slice(indexOfFirstStockTakeHistory, indexOfLastStockTakeHistory);

  const open_view_history_modal = (timestamp) => {
    const history_field = page_data?.history?.find((his) => his?.timestamp === timestamp);
    setSelectedHistory(history_field);
    setViewHistoryModal(true);
  };

  const close_view_history_modal = () => {
    setSelectedHistory([]);
    setViewHistoryModal(false);
  };

  const open_update_physical_stock_modal = () => {
    setUpdatePhysicalStockModal(!update_physical_stock_modal);
  };

  const close_update_physical_stock_modal = () => {
    setUpdatePhysicalStockModal(!update_physical_stock_modal);
  };

  const successUpdatePhysicalStockModal = () => {
    retreive_stock_take_details();
    close_update_physical_stock_modal();
    setActiveCardTab("Final Stock Take Report PDF");
  };

  const open_update_stock_take_products_modal = () => {
    setUpdateStockTakeProductsModal(!update_stock_take_products_modal);
  };

  const close_update_stock_take_products_modal = () => {
    setUpdateStockTakeProductsModal(!update_stock_take_products_modal);
  };

  const successupdate_stock_take_products_modal = () => {
    retreive_stock_take_details();
    close_update_stock_take_products_modal();
  };

  // State for selected brand filter
  const [selectedBrand, setSelectedBrand] = useState('all');
  const [filteredData, setFilteredData] = useState(page_data);

  // Extract unique brands from the data
  // const brands = useMemo(() => {
  //   const uniqueBrands = new Set();
  //   page_data?.products?.forEach(product => {
  //     uniqueBrands.add(product.category || 'Uncategorized');
  //   });
  //   return ['all', ...Array.from(uniqueBrands)].filter(Boolean);
  // }, [page_data]);

  // Filter data based on selected brand
  useEffect(() => {
    if (selectedBrand === 'all')
    {
      setFilteredData(page_data);
    } else
    {
      const filteredProducts = page_data?.products?.filter(
        product => product.category === selectedBrand
      ) || [];

      setFilteredData({
        ...page_data,
        products: filteredProducts
      });
    }
  }, [selectedBrand, page_data]);


  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Stock Take Details | ${reference_number}` : `Stock Take Details | ${reference_number}`} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="g-3">
            <BlockHeadContent>
              <BlockTitle page>{`Stock Date Details | ${reference_number}`}</BlockTitle>
              <Link to={`${process.env.PUBLIC_URL}/${tenant_info?.url_prefix}/stock_take`}>
                <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                  <Icon name="arrow-left"></Icon>
                  <span>Back</span>
                </Button>
              </Link>
              <Link to={`${process.env.PUBLIC_URL}/stock_take`}>
                <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
                  <Icon name="arrow-left"></Icon>
                </Button>
              </Link>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <UncontrolledDropdown>
                        <DropdownToggle tag="a" className="dropdown-toggle btn btn-white btn-dim btn-outline-light mt-2">
                          <span>Actions</span>
                          <Icon name="chevron-right" className="dd-indc"></Icon>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <ul className="link-list-opt no-bdr">
                            {
                              page_data?.status === app_consts.UNDERGOING_PROCESSING_LOWER && (user_info?.roles?.includes(app_consts.ADD_STOCK_TAKE) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && user_info?.profile_id === page_data?.employee?.profile?.id && (
                                <>
                                  <li>
                                    <DropdownItem
                                      tag="a"
                                      href="#dropdownitem"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setUploadStockTakeReportModal(!upload_stock_take_report_modal);
                                      }}
                                    >
                                      <span>Upload Stock Take Report</span>
                                    </DropdownItem>
                                  </li>
                                  <li>
                                    <DropdownItem
                                      tag="a"
                                      href="#dropdownitem"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        open_update_stock_take_products_modal();
                                      }}
                                    >
                                      <span>Update Stock Take Products</span>
                                    </DropdownItem>
                                  </li>
                                  <li>
                                    <DropdownItem
                                      tag="a"
                                      href="#dropdownitem"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        // open_update_order_status_modal();
                                      }}
                                    >
                                      <span>Cancel Stock Take</span>
                                    </DropdownItem>
                                  </li>
                                </>
                              )
                            }
                            {
                              page_data?.status === app_consts.COMPLETED_LOWER && !page_data?.updated_to_phsyical_stock && (user_info?.roles?.includes(app_consts.ADD_STOCK_TAKE) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && user_info?.profile_id === page_data?.employee?.profile?.id && (
                                <>
                                  <li>
                                    <DropdownItem
                                      tag="a"
                                      href="#dropdownitem"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        open_update_physical_stock_modal();
                                      }}
                                    >
                                      <span>Update Stock Values to Phsyical Stock</span>
                                    </DropdownItem>
                                  </li>
                                </>
                              )
                            }
                          </ul>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Stock Take Details..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && (page_data?.length > 0 || page_data !== null) ?
                        <>
                          <Block>
                            <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                          </Block>
                          {
                            activeCardTab === "Main Info" && (
                              <>
                                <div className="card-inner bg-white">
                                  <Block>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Main Information</BlockTitle>
                                    </BlockHead>
                                    <div className="profile-ud-list">
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Reference No.</span>
                                          <span className="profile-ud-value">{page_data?.reference_number || "--"}</span>
                                        </div>
                                      </div>
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Name</span>
                                          <span className="profile-ud-value">{page_data?.name || "--"}</span>
                                        </div>
                                      </div>
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Start Balance Date</span>
                                          <span className="profile-ud-value">{page_data?.stock_balance_start_date ? moment(page_data?.stock_balance_start_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                        </div>
                                      </div>
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">End Balance Date</span>
                                          <span className="profile-ud-value">{page_data?.stock_balance_end_date ? moment(page_data?.stock_balance_end_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                        </div>
                                      </div>
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Warehouse Name</span>
                                          <span className="profile-ud-value">{page_data?.warehouse?.name || "--"}</span>
                                        </div>
                                      </div>
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Status</span>
                                          <span className="profile-ud-value">
                                            <span className="tb-odr-status">
                                              <Badge
                                                color={
                                                  page_data?.status === app_consts.COMPLETED_LOWER
                                                    ? "success"
                                                    : "warning"
                                                }
                                                className="badge-dot"
                                              >
                                                {page_data?.status ? formatToSentenceCase(page_data?.status)?.toUpperCase() : "--"}
                                              </Badge>
                                            </span></span>
                                        </div>
                                      </div>
                                    </div>
                                  </Block>
                                </div>
                              </>
                            )
                          }
                          {
                            activeCardTab === "Stock Take Products" && (
                              <>
                                <div className="card-inner">
                                  <Block>
                                    <BlockBetween className="mb-4">
                                      <BlockHeadContent>
                                        <BlockTitle tag="h5">Stock Take Products</BlockTitle>
                                      </BlockHeadContent>
                                      <BlockHeadContent >
                                        {
                                          (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.ADD_STOCK_TAKE)) && page_data?.status === app_consts.UNDERGOING_PROCESSING_LOWER && (
                                            <>
                                              <div className="toggle-wrap nk-block-tools-toggle">
                                                <div className="toggle-expand-content">
                                                  <ul className="nk-block-tools g-3">
                                                    <li>
                                                      <div className="tb-odr-btns d-sm-inline">
                                                        <Button color="primary" size="sm" onClick={(e) => export_to_csv(e)}>
                                                          Export to CSV
                                                        </Button>
                                                      </div>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </>
                                          )
                                        }
                                      </BlockHeadContent>
                                    </BlockBetween>
                                    <div className="nk-tb-list is-separate is-medium mb-3">
                                      <DataTableHead className="nk-tb-item">
                                        <DataTableRow>
                                          <span className="sub-text">Brand</span>
                                        </DataTableRow>
                                        <DataTableRow size="lg">
                                          <span className="sub-text">Name</span>
                                        </DataTableRow>
                                        <DataTableRow size="lg">
                                          <span className="sub-text">Product Type</span>
                                        </DataTableRow>
                                        <DataTableRow size="lg">
                                          <span className="sub-text">Color</span>
                                        </DataTableRow>
                                        <DataTableRow size="lg">
                                          <span className="sub-text">Size</span>
                                        </DataTableRow>
                                        <DataTableRow size="lg">
                                          <span className="sub-text">Value (ZMW)</span>
                                        </DataTableRow>
                                        <DataTableRow size="md">
                                          <span className="sub-text">Status</span>
                                        </DataTableRow>
                                      </DataTableHead>
                                      {/*Head*/}
                                      {currentProducts.length > 0
                                        ? currentProducts.map((item) => (
                                          <DataTableItem key={item.id}>
                                            <DataTableRow size="sm">
                                              <div className="user-card">
                                                <div className="user-info">
                                                  <span className="tb-lead">
                                                    {item?.category || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                                  </span>
                                                  {/* <span>{item?.product?.category || "--"}  | {item?.product?.product_type || "--"} </span> */}
                                                </div>
                                              </div>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-product">
                                                <span className="tb-sub">{item?.product_name || "--"}</span>
                                              </span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-sub">{item?.product_type || "--"}</span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-sub">{item?.color || "--"}</span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-sub">{item?.size || "--"}</span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-sub">
                                                {item?.product_value !== null && item?.product_value !== undefined
                                                  ? formatNumber(item.product_value)
                                                  : ""}
                                              </span>
                                            </DataTableRow>
                                            <DataTableRow>

                                              <span className="tb-odr-status">
                                                <Badge
                                                  color={
                                                    item?.status === app_consts.ACTIVE
                                                      ? "success"
                                                      : "warning"
                                                  }
                                                  className="badge-dot"
                                                >
                                                  {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                                                </Badge>
                                              </span>
                                            </DataTableRow>
                                          </DataTableItem>
                                        ))
                                        : null}
                                    </div>
                                    {currentProducts.length > 0 && (
                                      <div className="mt-3">
                                        <PaginationComponent
                                          itemPerPage={productsPerPage}
                                          totalItems={page_data?.products?.length}
                                          paginate={paginate}
                                          currentPage={currentProductsPage}
                                        />
                                      </div>
                                    )}
                                  </Block>
                                </div>

                              </>
                            )
                          }
                          {
                            activeCardTab === "Stock Take History" && (
                              <>
                                <div className="card-inner">
                                  <Block>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Stock Take History</BlockTitle>
                                    </BlockHead>
                                    <div className="nk-tb-list is-separate is-medium mb-3">
                                      <DataTableHead className="nk-tb-item">
                                        <DataTableRow>
                                          <span className="sub-text">Message</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="sub-text">Actor</span>
                                        </DataTableRow>
                                        <DataTableRow size="lg">
                                          <span className="sub-text">Timestamp</span>
                                        </DataTableRow>
                                        <DataTableRow size="md">
                                          <span className="sub-text">Action</span>
                                        </DataTableRow>
                                      </DataTableHead>
                                      {/*Head*/}
                                      {currentStockTakeHistory.length > 0
                                        ? currentStockTakeHistory.map((item) => (
                                          <DataTableItem key={item.timestamp}>
                                            <DataTableRow>
                                              <span className="tb-sub">{item?.message ? addThreeDots(item?.message, 60) : "--"}</span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-sub">{item?.name || "--"}</span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-product">
                                                <span className="tb-sub">{item?.timestamp ? moment(item?.timestamp).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                              </span>
                                            </DataTableRow>
                                            <DataTableRow className="nk-tb-col-tools">
                                              <div className="tb-odr-btns d-none d-sm-inline">
                                                <Button color="primary" size="sm" className="btn btn-dim" onClick={() => open_view_history_modal(item?.timestamp)}>
                                                  View
                                                </Button>
                                              </div>
                                              <Button className="btn-pd-auto d-sm-none">
                                                <Icon name="chevron-right"></Icon>
                                              </Button>
                                            </DataTableRow>
                                          </DataTableItem>
                                        ))
                                        : null}
                                    </div>
                                  </Block>
                                </div>


                                <ViewHistoryDetailsModal isOpen={view_history_modal} closeModal={close_view_history_modal} data={selectedHistory} title="Stock Take History Details" />
                              </>
                            )
                          }
                          {
                            activeCardTab === "Initial Stock Take Report PDF" && (
                              <>
                                {
                                  page_data?.status === app_consts.COMPLETED_LOWER ?
                                    <>
                                      <div className="card-inner">
                                        <Block>
                                          <BlockHead>
                                            <BlockTitle tag="h5">Stock Take Report PDF</BlockTitle>
                                            {/* Brand filter dropdown */}
                                            {/* <div style={{ marginBottom: '1rem' }}>
                                              <label htmlFor="brand-filter" style={{ marginRight: '0.5rem' }}>Filter by Brand:</label>
                                              <select
                                                id="brand-filter"
                                                value={selectedBrand}
                                                onChange={(e) => setSelectedBrand(e.target.value)}
                                                style={{
                                                  padding: '0.5rem',
                                                  borderRadius: '4px',
                                                  border: '1px solid #ccc'
                                                }}
                                              >
                                                {brands.map(brand => (
                                                  <option key={brand} value={brand}>
                                                    {brand === 'all' ? 'All Brands' : brand}
                                                  </option>
                                                ))}
                                              </select>
                                            </div> */}
                                          </BlockHead>
                                          <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
                                            <PDFViewer height="100%" width="100%" showToolbar>
                                              <StockTakePDF stock_take_details={filteredData} tenant_info={tenant_info} />
                                            </PDFViewer>
                                          </div>
                                        </Block>
                                      </div>
                                    </>
                                    :
                                    <>
                                      <AuthTenantNoData no_logo tenant_info={tenant_info} no_data_message={"PDF can only be viewed when Stock Take Status is 'Completed'"} />
                                    </>
                                }
                              </>
                            )
                          }
                          {
                            activeCardTab === "Final Stock Take Report PDF" && (
                              <>
                                {
                                  page_data?.status === app_consts.COMPLETED_LOWER && page_data?.updated_to_phsyical_stock ?
                                    <>
                                      <div className="card-inner">
                                        <Block>
                                          <BlockHead>
                                            <BlockTitle tag="h5">Stock Take Report PDF</BlockTitle>
                                          </BlockHead>
                                          <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
                                            <PDFViewer height="100%" width="100%" showToolbar>
                                              <UpdateStockTakeReportPDF stock_take_details={page_data} tenant_info={tenant_info} />
                                            </PDFViewer>
                                          </div>
                                        </Block>
                                      </div>
                                    </>
                                    :
                                    <>
                                      <AuthTenantNoData no_logo tenant_info={tenant_info} no_data_message={"PDF can only be viewed when Stock Take Status is 'Completed' and After Physical Stock Updates have been made."} />
                                    </>
                                }
                              </>
                            )
                          }
                          {
                            activeCardTab === "Stock Take Full Report" && (
                              <>
                                {
                                  page_data?.status === app_consts.COMPLETED_LOWER ?
                                    <>
                                      <div className="card-inner">
                                        <Block>
                                          <BlockHead>
                                            <BlockTitle tag="h5">Stock Take Full Report</BlockTitle>
                                          </BlockHead>

                                        </Block>
                                      </div>
                                    </>
                                    :
                                    <>
                                      <AuthTenantNoData no_logo tenant_info={tenant_info} no_data_message={"Stock Take Full Report can only be viewed when Stock Take Status is 'Completed'"} />
                                    </>
                                }
                              </>
                            )
                          }
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Stock Data Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
      <UpdateStockTakeValuesToPhysicalStockModal isOpen={update_physical_stock_modal} successFunction={successUpdatePhysicalStockModal} tenant_info={tenant_info} user_info={user_info} data={page_data} closeModal={close_update_physical_stock_modal} />
      <UploadStockTakeReportModal isOpen={upload_stock_take_report_modal} successFunction={successUploadStockTakeReport} closeModal={closeUploadStockTakeModal} tenant_info={tenant_info} user_info={user_info} data={page_data} />
      <UpdateStockTakeProducts isOpen={update_stock_take_products_modal} closeModal={close_update_stock_take_products_modal} successFunction={successupdate_stock_take_products_modal} tenant_info={tenant_info} user_info={user_info} data={page_data} />
    </>
  );
};

export default StockTakeDetails;